import { render } from "./ClientServicesLimitationsSettings.vue?vue&type=template&id=5653f3ac"
import script from "./ClientServicesLimitationsSettings.vue?vue&type=script&lang=js"
export * from "./ClientServicesLimitationsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__